import _regeneratorRuntime from "babel-runtime/regenerator";

function _asyncToGenerator(fn) {
  return function () {
    var gen = fn.apply(this, arguments);
    return new Promise(function (resolve, reject) {
      function step(key, arg) {
        try {
          var info = gen[key](arg);
          var value = info.value;
        } catch (error) {
          reject(error);
          return;
        }

        if (info.done) {
          resolve(value);
        } else {
          return Promise.resolve(value).then(function (value) {
            step("next", value);
          }, function (err) {
            step("throw", err);
          });
        }
      }

      return step("next");
    });
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

import React from "react";
import PropTypes from "prop-types";
import Cleave from "cleave.js/react";
import CleavePhone from "cleave.js/dist/addons/cleave-phone.i18n";
import Modal from "../../../Misc/Modal";
import { validatePhone, mobileAndTabletCheck } from "../../../Misc/Utils";
import { Mobile, Check } from "../../../Misc/Icons";
import Button from "../../../Misc/Buttons/DefaultBlueButton";
import QRCode from "qrcode.react";
import { isMediaRecorderAvailable } from "./Utils";

var PhoneNumberModal = function (_React$Component) {
  _inherits(PhoneNumberModal, _React$Component);

  function PhoneNumberModal() {
    var _this2 = this;

    var _temp, _this, _ret;

    _classCallCheck(this, PhoneNumberModal);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
      selectedNumber: "",
      success: false
    }, _this.selectNumber = function (number) {
      return _this.setState({
        selectedNumber: number
      });
    }, _this.sendLink = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee() {
      var selectedNumber, sendLink;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              selectedNumber = _this.state.selectedNumber;

              if (validatePhone(selectedNumber)) {
                _context.next = 3;
                break;
              }

              return _context.abrupt("return");

            case 3:
              _this.setState({
                busy: true
              });

              sendLink = _this.props.mobileRecordSettings.sendLink;
              _context.next = 7;
              return sendLink(_this.state.selectedNumber);

            case 7:
              _this.setState({
                success: true
              });

            case 8:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this2);
    })), _this.close = function () {
      _this.props.onClose();
    }, _this.submitForm = function (e) {
      e.preventDefault();

      _this.sendLink();
    }, _this.receiveQrCodeData = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee2() {
      var data;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              if (!_this.state.receivingQrData) {
                _context2.next = 2;
                break;
              }

              return _context2.abrupt("return");

            case 2:
              _this.setState({
                receivingQrData: true
              });

              _context2.next = 5;
              return _this.props.qrCodeData();

            case 5:
              data = _context2.sent;

              _this.setState({
                qrCodeData: data,
                receivingQrData: false
              });

            case 7:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, _this2);
    })), _temp), _possibleConstructorReturn(_this, _ret);
  }

  PhoneNumberModal.prototype.componentDidUpdate = function componentDidUpdate(previousProps) {
    if (!previousProps.active && this.props.active) {
      this.setState({
        selectedNumber: "",
        success: false,
        busy: false
      });
    }
  };

  PhoneNumberModal.prototype.renderQrCode = function renderQrCode() {
    if (!this.props.qrCodeData) {
      return;
    }

    var _state = this.state,
        qrCodeData = _state.qrCodeData,
        receivingQrData = _state.receivingQrData;
    return React.createElement("div", {
      className: "modal__mobile",
      style: {
        marginBottom: 20,
        textAlign: "center"
      }
    }, !qrCodeData && mobileAndTabletCheck() && React.createElement(Button, {
      onClick: this.receiveQrCodeData,
      disabled: receivingQrData,
      style: {
        marginBottom: 20
      }
    }, receivingQrData ? "processing..." : "use assistant app"), qrCodeData && mobileAndTabletCheck() && React.createElement("a", {
      href: qrCodeData,
      target: "_blank",
      className: "button button--style-default button--size-m button--color-blue-ribbon undefined",
      style: {
        marginBottom: 20
      }
    }, "press to launch assistant app"), qrCodeData ? React.createElement(QRCode, {
      value: qrCodeData,
      size: 200,
      includeMargin: true
    }) : React.createElement(Button, {
      onClick: this.receiveQrCodeData,
      disabled: receivingQrData
    }, "show QR code"));
  };

  PhoneNumberModal.prototype.renderFormModal = function renderFormModal() {
    var _this3 = this;

    var _props = this.props,
        active = _props.active,
        mobileRecordSettings = _props.mobileRecordSettings;
    var _mobileRecordSettings = mobileRecordSettings.knownNumbers,
        knownNumbers = _mobileRecordSettings === undefined ? [] : _mobileRecordSettings;
    var _state2 = this.state,
        selectedNumber = _state2.selectedNumber,
        busy = _state2.busy,
        qrCodeData = _state2.qrCodeData;
    return React.createElement(Modal, {
      active: active || !isMediaRecorderAvailable(),
      title: "Record on mobile device",
      text: "Get a magic link to record video on your mobile device."
    }, React.createElement("form", {
      className: "modal__form",
      onSubmit: this.submitForm
    }, React.createElement("div", {
      className: "form form--style-account"
    }, this.renderQrCode(), React.createElement("label", {
      className: "form__label"
    }, "receiving mobile phone"), React.createElement("div", {
      className: "form__container"
    }, React.createElement(Cleave, {
      placeholder: "enter phone number",
      className: "form__input",
      options: {
        phone: true,
        phoneRegionCode: "US"
      },
      value: selectedNumber,
      onChange: function onChange(e) {
        return _this3.selectNumber(e.target.rawValue);
      },
      disabled: busy
    })), React.createElement("div", {
      className: "modal__mobile"
    }, knownNumbers.map(function (number) {
      return React.createElement("button", {
        type: "button",
        className: "mobile mobile--style-dark " + (selectedNumber === number ? "is-active" : null),
        key: number,
        onClick: function onClick() {
          return _this3.selectNumber(number);
        },
        disabled: busy
      }, React.createElement("span", {
        className: "mobile__icon"
      }, React.createElement(Mobile, null)), React.createElement("span", {
        className: "mobile__number"
      }, number), React.createElement("span", {
        className: "mobile__check"
      }, React.createElement(Check, null)));
    }), React.createElement(Button, {
      disabled: busy
    }, "send"), qrCodeData && React.createElement("div", {
      className: "modal__text",
      style: {
        marginTop: 10,
        textAlign: "center"
      }
    }, "Stay tuned, your video will appear here shortly or you can find it in the Videos folder."), isMediaRecorderAvailable() && React.createElement("button", {
      type: "reset",
      className: "button button--link",
      onClick: this.close,
      disabled: busy
    }, qrCodeData ? "close" : "cancel")))));
  };

  PhoneNumberModal.prototype.renderSuccessModal = function renderSuccessModal() {
    return React.createElement(Modal, {
      active: this.props.active,
      title: "Check your mobile phone",
      text: "We\u2019ve sent a message with a recording link to:"
    }, React.createElement("div", {
      className: "modal__mobile"
    }, React.createElement("button", {
      className: "mobile mobile--style-dark"
    }, React.createElement("span", {
      className: "mobile__icon"
    }, React.createElement(Mobile, null)), React.createElement("span", {
      className: "mobile__number"
    }, this.state.selectedNumber)), React.createElement("div", {
      className: "modal__text",
      style: {
        marginTop: 10,
        textAlign: "center"
      }
    }, "Stay tuned, your video will appear here shortly or you can find it in the Videos folder."), React.createElement("div", null, React.createElement("button", {
      type: "reset",
      className: "button button--link",
      onClick: this.close
    }, "close"))));
  };

  PhoneNumberModal.prototype.render = function render() {
    return this.state.success ? this.renderSuccessModal() : this.renderFormModal();
  };

  return PhoneNumberModal;
}(React.Component);

PhoneNumberModal.propTypes = process.env.NODE_ENV !== "production" ? {
  active: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
  mobileRecordSettings: PropTypes.object.isRequired,
  qrCodeData: PropTypes.func
} : {};
export default PhoneNumberModal;